import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings.component';
import { SettingsRoutingModule } from './settings-routing.module';
import { CustomGridModule } from 'src/app/core/custom-grid/custom-grid.module';
import { CustomDialogModule } from 'src/app/core/custom-dialog/custom-dialog.module';
import { SettingsAnagraficheComponent } from './settings-anagrafiche/settings-anagrafiche.component';
import { SettingsCacheComponent } from './settings-cache/settings-cache.component';
import { SettingsStyleComponent } from './settings-style/settings-style.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CameraComponent } from 'src/app/core/camera/camera.component';
import { CustomTabsModule } from "../../core/custom-tabs/custom-tabs.module";



@NgModule({
  declarations: [
    SettingsComponent,
    SettingsAnagraficheComponent,
    SettingsCacheComponent,
    SettingsStyleComponent,
  ],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    CustomGridModule,
    CustomDialogModule,
    FormsModule,
    ReactiveFormsModule,
    CameraComponent,
    CustomTabsModule
],
  exports: [
    SettingsComponent,
    SettingsAnagraficheComponent,
    SettingsCacheComponent,
    SettingsStyleComponent,
  ]
})
export class SettingsModule { }
